import "./sessao"; // primeiro: anexa a sessão assinada em toda chamada /api/
import { createRoot } from "react-dom/client";
import App from "./App";
import AvaliacaoPublica from "./components/AvaliacaoPublica";
import TriagemPublica from "./components/TriagemPublica";
import DiscPublica from "./components/DiscPublica";
import ClimaPublica from "./components/ClimaPublica";
import ProgramaPublica from "./components/ProgramaPublica";
import ConvitePublico from "./components/ConvitePublico";
import "./styles.css";
// Central de eventos (Endomarketing): módulo grande o bastante para ter o
// próprio arquivo — usa os mesmos tokens de tema do styles.css.
import "./eventos.css";
// Convite de entrevista (o modal do RH + a página que o candidato abre).
import "./convite.css";

const el = document.getElementById("root");
if (!el) throw new Error("Elemento #root não encontrado");

/**
 * Rota pública da avaliação: /avaliacao/<token>. É renderizada FORA do App
 * (sem Login/AccessGate) — o token do link é a credencial do gestor.
 * decodeURIComponent lança URIError em percent-encoding malformado; nesse caso
 * mantemos o valor cru (o servidor devolve 404 → tela "Link indisponível"),
 * em vez de derrubar a página com tela branca.
 */
function tokenDaRota(prefixo: string): string | null {
  const m = window.location.pathname.match(new RegExp(`^/${prefixo}/([^/]+)/?$`));
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]);
  } catch {
    return m[1];
  }
}

const tokenAvaliacao = tokenDaRota("avaliacao");
// Triagem de currículo: o link que o candidato recebe no WhatsApp.
const tokenTriagem = tokenDaRota("triagem");
// DISC: o link do teste comportamental, enviado ao candidato pelo WhatsApp.
const tokenDisc = tokenDaRota("disc");
// Pesquisa de clima: o link individual de cada colaborador.
const tokenClima = tokenDaRota("clima");
// Programas internos (Realize um Sonho / Ideias que Transformam): o link que o
// RH divulga e o QR Code do cartaz. Uma rota só — o servidor diz qual programa.
const tokenPrograma = tokenDaRota("programa");
// Convite de entrevista: o link que o CANDIDATO recebe depois de agendada a
// entrevista (dia, horário, endereço e quem procurar na recepção).
const tokenConvite = tokenDaRota("entrevista");

createRoot(el).render(
  tokenAvaliacao ? (
    <AvaliacaoPublica token={tokenAvaliacao} />
  ) : tokenTriagem ? (
    <TriagemPublica token={tokenTriagem} />
  ) : tokenDisc ? (
    <DiscPublica token={tokenDisc} />
  ) : tokenClima ? (
    <ClimaPublica token={tokenClima} />
  ) : tokenPrograma ? (
    <ProgramaPublica token={tokenPrograma} />
  ) : tokenConvite ? (
    <ConvitePublico token={tokenConvite} />
  ) : (
    <App />
  ),
);
